import React from 'react'
import { PopoverSeeker } from "@ui-seeker/core"
import PopoverTitle from "./Title"
import PopoverLinks from "./Links"
import PopoverCarFeatures from "./Features"


export default function AnalyzerPopover({ isOpen, onClose, data, hideEvolution = false }) {

	const { price_data, evolutionFilter } = data
	return <PopoverSeeker
		anchorEl={isOpen}
		onClose={onClose}
		anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
		transformOrigin={{ vertical: 'center', horizontal: 'left' }}
		arrowProps={{ sx: { top: '35%', left: -6 } }}
		slotProps={{ paper: { sx: { p: 2, backgroundColor: 'white' } } }}
	>
		<PopoverTitle onClose={onClose} carDescription={price_data?.car_description}/>
		<PopoverCarFeatures priceData={price_data}/>
		<PopoverLinks
			id_search={price_data?.id_search}
			screenshot={price_data?.screenshot}
			evolutionFilter={evolutionFilter}
			priceData={price_data}
			hideEvolution={hideEvolution}
		/>
	</PopoverSeeker>
}